/**
 * Derives the breakdown-location options for a chosen segment.
 *
 *   1. `segment.fromStation`
 *   2. `segment.toStation`
 *   3. all real X-stations returned by the `breakdownStations` query
 *
 * Every option carries the underlying real Station object; no synthetic
 * sentinels. Labels render as `CODE (Name)` for a consistent read.
 *
 * @param {{ id: string, fromStation: Object, toStation: Object } | null | undefined} segment
 * @param {Array<Object>} [xStations=[]] Real X-station list from the backend.
 * @returns {Array<{ id: string, label: string, station: Object }>}
 */
export const deriveBreakdownLocationOptions = (segment, xStations = []) => {
	if (!segment?.fromStation?.id || !segment?.toStation?.id) return [];

	const toOption = (station) => ({
		id: station.id,
		label: station.name ? `${station.code} (${station.name})` : station.code,
		station,
	});

	return [toOption(segment.fromStation), toOption(segment.toStation), ...xStations.map(toOption)];
};
